/**
 * MmdBufferKind Constants
 */
export class MmdBufferKind {
    static AdditionalUV1Kind = "additionalUv1";
    static AdditionalUV2Kind = "additionalUv2";
    static AdditionalUV3Kind = "additionalUv3";
    static AdditionalUV4Kind = "additionalUv4";
    static MatricesSdefCKind = "matricesSdefC";
    static MatricesSdefRW0Kind = "matricesSdefRW0";
    static MatricesSdefRW1Kind = "matricesSdefRW1";
    // for prevent data loss
    static MatricesSdefR0Kind = "matricesSdefR0";
    static MatricesSdefR1Kind = "matricesSdefR1";
    static EdgeScaleKind = "edgeScale";
}
